import React from "react"
import { Link } from "gatsby"

import {
  FaGithub,
  FaLinkedin,
  FaTwitter,
  FaCoffee,
  FaSuitcase,
} from "react-icons/fa"

import { rhythm, scale } from "../utils/typography"
import styled from "@emotion/styled"

import logo from "../../content/assets/logo.png"

const minMedia = `45rem`

// line-height: 4rem;
const HeaderContent = styled.div`
  margin: 0 auto;
  padding-left: ${rhythm(3 / 4)};
  padding-right: ${rhythm(3 / 4)};
  max-width: ${rhythm(40)};

  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-flow: column nowrap;
  font-family: Red Hat Display, Roboto, Arial, Noto Sans, sans-serif;
  height: 100%;



  @media (min-width: ${minMedia}) {
    flex-flow: row nowrap;
  }
`

//    display: none;
const LogoText = styled.span`
  font-family: Red Hat Display, Roboto, Arial, Noto Sans, sans-serif;
  font-size: 1.5rem;
  line-height: 4rem;
  font-weight: bold;
  display: inline-block;
  @media (min-width: ${minMedia}) {
    display: inline-block;
  }
`

// line-height: 4rem;
// h1 {
//   line-height: 4rem;
// }
const NavScroll = styled.div`
  max-width: 100%;

  margin-bottom:0.5rem;
  
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-flex-shrink: 1;
  -ms-flex-negative: 1;
  flex-shrink: 1;

  @media (min-width: ${minMedia}) {
    line-height: 4rem;
    margin-bottom:0rem;
  }
`

const Nav = styled.nav`

  padding-left: ${rhythm(3 / 4)};
  padding-right: ${rhythm(3 / 4)};
  max-width: ${rhythm(40)};

  overflow-x: auto;

  min-width: 0;
`

const Ul = styled.ul`
  -webkit-align-self: flex-end;
  -ms-flex-item-align: end;
  align-self: flex-end;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  list-style: none;
  margin: 0rem;

  overflow-x: auto;
`

const Li = styled.li`
  display: block;
  margin: 0rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
`
// line-height: 4rem;
const HeaderLink = styled(Link)`
  border-bottom: 2px solid transparent;

  display: block;
  font-size: 1.125rem;

  position: relative;
  -webkit-text-decoration: none;
  text-decoration: none;
  z-index: 1;

  &:hover {
    color: "#f4cc25";
  }
  &.active {
    color: #f4cc25;
    border-bottom-color: #f4cc25;
  }
`

const Icons = styled.div`
  @media (min-width: ${minMedia}) {
    -webkit-align-self: flex-end;
    -ms-flex-item-align: end;
    align-self: flex-end;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
`

const IconLink = styled.a`
  color: #78757a;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 1.7rem;
  line-height: 3rem;

  &:hover {
    color: #f4cc25;
  }
`

const Header = styled.header`
  background-color: rgba(255, 255, 255, 0.985);
  z-index: 5;
  left: 0rem;
  right: 0rem;
  position: sticky;

  border-bottom: 1px solid #eee;
  @media (min-width: ${minMedia}) {
    position: fixed;
    height: 4rem;
  }
`

const Main = styled.main`
  margin-left: auto;
  margin-right: auto;
  max-width: ${rhythm(40)};
  padding: ${rhythm(1)} ${rhythm(3 / 4)};

  @media (min-width: ${minMedia}) {
    padding-top: calc(4rem + ${rhythm(1)});
  }
`

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  let header

  // if (location.pathname === rootPath) {
  header = (
    <Link
      style={{
        boxShadow: `none`,
        color: `inherit`,
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flexShrink : 0,
      }}
      to={`/`}
    >
      <img
        src={logo}
        alt="Logo"
        style={{
          maxWidth: "none",
          height: "2.5rem",
          width: "2.5rem",
          verticalAlign: "middle",
          marginBottom: rhythm(0),
          marginRight: "10px",
        }}
      />
      <LogoText>{title}</LogoText>
    </Link>
  )
  // } else {
  //   header = (
  //     <h3
  //       style={{
  //         fontFamily: `Red Hat Display, sans-serif`,
  //         marginTop: 0,
  //       }}
  //     >
  //       <Link
  //         style={{
  //           boxShadow: `none`,
  //           color: `inherit`,
  //         }}
  //         to={`/`}
  //       >
  //         {title}
  //       </Link>
  //     </h3>
  //   )
  // }
  return (
    <div>
      <Header>
        <HeaderContent>
          {header}
          <NavScroll>
            <Nav>
              <Ul>
                <Li>
                  <HeaderLink to={`/`} activeClassName="active">
                    Projects
                  </HeaderLink>
                </Li>
              
              </Ul>
            </Nav>
          </NavScroll>
          <Icons>
            <IconLink href="https://mdpgroup.com/">
              <FaSuitcase />
            </IconLink>
            <IconLink href="https://github.com/mdpgroup">
              <FaGithub />
            </IconLink>
            <IconLink href="https://twitter.com/digitalmdp">
              <FaTwitter />
            </IconLink>
            <IconLink href="https://www.linkedin.com/company/digitalmdp/">
              <FaLinkedin />
            </IconLink>
          </Icons>
        </HeaderContent>
      </Header>
      <Main>{children}</Main>
      <footer>
        {/* © {new Date().getFullYear()}, Built with
        {` `}
        <a href="https://www.gatsbyjs.org">Gatsby</a> */}
      </footer>
    </div>
  )
}

export default Layout
